import { Alert, Button, Checkbox, Divider, Space, Tooltip, Typography } from "antd";
import { useState } from "react";

export default function ListSharePublicTab(props) {
    const {
        list = {},
        close = () => { },
        session = {},
        setShared = () => { },
        drawReturnToReportCardButton = () => { },
    } = props;

    const { shared_status = "none", name = "" } = list;

    const is_public = (shared_status === "everyone" || shared_status === "all_booksellers");

    const drawButton = () => {
        if (is_public) {
            // is public
            return (
                <Tooltip title="This will unshare the catalogue with ALL stores">
                    <Button type="primary" onClick={() => setShared(false, false, false)}>Make Private</Button>
                </Tooltip>
            )
        } else {
            // is private
            return (
                <Tooltip title="This will share the catalogue with ALL stores">
                    <Button type="primary" onClick={() => setShared(true, false, false)}>Share Publicly</Button>
                </Tooltip>
            )
        }
    }

    return (
        <div style={{ "padding": "20px" }}>
            <Typography.Title level={5}>Publicly Share: <em>"{name}"</em></Typography.Title>
            <Typography.Paragraph>
                {session?.is_canadian ? 
                    <>Sharing this publicly means that you are sharing it with all CA bookstores. <br/><br/>
                    Bookmanager stores will view this catalogue on their own "biz" admin site, and non-Bookmanager stores will be able to see this list on Bookmanager.com under Catalogues. <br/><br/>
                    </>: 
                    <>Sharing this publicly means that you are sharing it with all US bookstores.<br/><br/></>}
                (Once a store has viewed the catalogue, you can no longer 'unshare' it with them).
            </Typography.Paragraph>
            {(is_public && <Alert type="info" description={<>This catalogue is currently Public. Click "Make Private" to unshare publicly. </>} />)}
            <Divider />
            <div className="float-flex">
                <Space>
                    {drawReturnToReportCardButton()}
                    <Button type="danger" onClick={() => close()}>Cancel</Button>
                </Space>
                {drawButton()}
            </div>
        </div>
    )
}